module.exports = __webpack_public_path__ + "img/jb_t3411_16_1999_.prt.e2bf5e90.jpg";